export default __webpack_public_path__ + "static/media/tinder-clone.441894f6.mov";